import React, { useEffect } from 'react';
import { ExpiryLevel } from '../useExpiryStatus';

interface SyncExpiryAlertProps {
  level: ExpiryLevel;
  expiresAt: number | null;
}

const SyncExpiryAlert = ({ level, expiresAt }: SyncExpiryAlertProps) => {
  useEffect(() => {
    if (level !== 'none') window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [level]);

  if (level === 'none' || expiresAt === null) return null;

  const isExpired = level === 'expired';
  const expiryTimeLabel = new Date(expiresAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

  return (
    <div className={`alert ${isExpired ? 'alert-danger' : 'alert-warning'} d-flex align-items-center mb-2`}>
      <i className="bi-exclamation-triangle-fill me-2" />
      <div>
        {isExpired
          ? <>This synced data expired at <strong>{expiryTimeLabel}</strong>. Please go back and sync again.</>
          : <>This synced data will expire at <strong>{expiryTimeLabel}</strong>. Finish importing before then, or go back and sync again.</>}
      </div>
    </div>
  );
};

export default SyncExpiryAlert;
